import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

// under systemjs, moment is actually exported as the default export, so we account for that
const momentConstructor: (value?: any) => moment.Moment = (moment as any).default || moment;

@Pipe({ name: 'amDateFormatEx', pure: false })
export class DateFormatPipeEx implements PipeTransform {
    public transform(value: Date | moment.Moment | string | number, ...args: any[]): string {
        if (!value) return '';

        return momentConstructor(value).format(args[0]);
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/date-format.pipe.ts